import errors from 'src/i18n/locales/en/errors.json';
import account from 'src/i18n/locales/es/account.json';
import activity from 'src/i18n/locales/es/activity.json';
import aiAgents from 'src/i18n/locales/es/ai-agents.json';
import appointments from 'src/i18n/locales/es/appointments.json';
import broadcast from 'src/i18n/locales/es/broadcast.json';
import calendar from 'src/i18n/locales/es/calendar.json';
import common from 'src/i18n/locales/es/common.json';
import contactTimeline from 'src/i18n/locales/es/contact-timeline.json';
import contacts from 'src/i18n/locales/es/contacts.json';
import conversations from 'src/i18n/locales/es/conversations.json';
import dashboard from 'src/i18n/locales/es/dashboard.json';
import header from 'src/i18n/locales/es/header.json';
import instagramChannel from 'src/i18n/locales/es/instagram-channel.json';
import metrics from 'src/i18n/locales/es/metrics.json';
import notes from 'src/i18n/locales/es/notes.json';
import notifications from 'src/i18n/locales/es/notifications.json';
import smsChannel from 'src/i18n/locales/es/sms-channel.json';
import tasks from 'src/i18n/locales/es/tasks.json';
import user from 'src/i18n/locales/es/user.json';
import whatsappChannel from 'src/i18n/locales/es/whatsapp-channel.json';

export const es = {
  account,
  activity,
  aiAgents,
  appointments,
  broadcast,
  calendar,
  common,
  contacts,
  contactTimeline,
  conversations,
  dashboard,
  errors,
  header,
  instagramChannel,
  metrics,
  notes,
  notifications,
  smsChannel,
  tasks,
  user,
  whatsappChannel,
};
